import { Component, EventEmitter, Input, NgModule, Output } from '@angular/core';

import { CommonModule } from '@angular/common';
import { WHideEmptyModule } from '@wipo/w-angular/directives';
import { toHeadingLevel, WHeadingLevel } from '@wipo/w-angular/shared';

@Component({
    selector: 'w-page-section',
    templateUrl: './w-page-section.component.html',
    host: {
        class: 'b-page-section',
        '[class.b-page-section--is-collapsed]': 'collapsed',
        // 'wf-modal-section': 'modalPage'
    },
    standalone: false
})
/*
@id w-page-section
@name w-page-section
@status release
@description
*/
export class WPageSectionComponent {
  @Input() title = '';
  @Input() headingLevel: WHeadingLevel = 2; // title heading level 1-6 or 'h1'-'h6'
  @Input() collapsed = false;
  @Output() wToggle = new EventEmitter<boolean>(); // click on toggle
  @Output() wChange = new EventEmitter<boolean>(); // open/close state has changed
  get toggleMatIcon(){
    return this.collapsed ? 'chevron_right' : 'expand_more';
  }
  get level() {
    return toHeadingLevel(this.headingLevel, 2);
  }
  toggleCollapsed() {
    const newState = !this.collapsed;
    // we want to do 3 things in different cycles: emit toggle event, change collapsed state and emit change event
    this.wToggle.emit(newState);
    setTimeout(()=>{
      this.collapsed = newState;
      setTimeout(()=>{
        this.wChange.emit(newState);
      })
    })
  }
}
@NgModule({
  imports: [CommonModule, WHideEmptyModule],
  exports: [WPageSectionComponent],
  declarations: [WPageSectionComponent]
})
export class WPageSectionModule { }
